<template>
  <el-row class="page-menu">
    <el-col
      :span="10"
      class="tree-container"
    >
      <div class="title">菜单信息</div>
      <el-tree
        ref="menuTree"
        :data="menuData"
        node-key="id"
        :highlight-current="true"
        @node-click="getNodeData"
        :props="defaultProps"
      >
      </el-tree>
      <yh-button
        size="small"
        style="margin-top: 20px;"
        @click="handleAddClick"
        v-if="functionList.includes('321102216148258816')"
      >新增菜单</yh-button>
    </el-col>
    <el-col
      :span="14"
      class="form-table"
      v-show="isShow"
    >
      <div class="title">菜单详情</div>
      <el-form
        ref="formMenu"
        :model="formMenu"
        label-width="120px"
        disabled
      >
        <el-form-item label="菜单ID">
          <el-input :value="formMenu.id | blankValue" />
        </el-form-item>
        <el-form-item label="菜单名称">
          <el-input :value="formMenu.menuName | blankValue" />
        </el-form-item>
        <el-form-item label="菜单类型">
          <el-input :value="formMenu.menuType | menuType | blankValue"></el-input>
        </el-form-item>
        <el-form-item label="菜单url">
          <el-input
            type="textarea"
            autosize
            :value="formMenu.menuUrl | blankValue"
          ></el-input>
        </el-form-item>
        <el-form-item label="路由url">
          <el-input
            type="textarea"
            autosize
            :value="formMenu.routerUrl | blankValue"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单描述">
          <el-input
            type="textarea"
            autosize
            :value="formMenu.menuDesc | blankValue"
          />
        </el-form-item>
        <el-form-item label="上级菜单">
          <el-input :value="formMenu.parentName | blankValue" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input :value="formMenu.createTime | formatTime | blankValue" />
        </el-form-item>
        <el-form-item label="创建人ID">
          <el-input :value="formMenu.createUserid | blankValue" />
        </el-form-item>
        <el-form-item label="修改时间">
          <el-input :value="formMenu.updateTime | formatTime | blankValue" />
        </el-form-item>
        <el-form-item label="修改人ID">
          <el-input :value="formMenu.updateUserid | blankValue" />
        </el-form-item>
      </el-form>
      <section class="operation-button">
        <el-button
          size="small"
          @click="handleUpdateClick"
          v-if="functionList.includes('321102326055800832')"
        >修改</el-button>
        <el-button
          class="text--red"
          size="small"
          @click="delConfirm"
          v-if="functionList.includes('321102424777134080')"
        >删除</el-button>
      </section>
    </el-col>

    <!-- 新增页面 -->
    <yh-dialog
      title="新增菜单"
      :close-on-click-modal="false"
      :visible.sync="visibleAdd"
    >
      <el-form
        class="hide-error"
        label-width="100px"
        :model="addFormData"
        ref="addForm"
      >
        <el-form-item
          label="菜单类型"
          prop="menuType"
          required
        >
          <el-radio-group v-model="addFormData.menuType">
            <el-radio label="0">根菜单</el-radio>
            <el-radio label="1">节点菜单</el-radio>
            <el-radio label="2">叶子菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="菜单名称"
          required
          prop="menuName"
        >
          <el-input
            placeholder="请输入菜单名称，不超过20字"
            v-model.trim="addFormData.menuName"
          ></el-input>
        </el-form-item>
        <section v-show="isLeafMenu(addFormData.menuType)">
          <el-form-item
            label="菜单url"
            required
            prop="menuUrl"
          >
            <el-input
              v-model.trim="addFormData.menuUrl"
              placeholder="请输入相对url，不超过200字"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="路由url"
            prop="routerUrl"
          >
            <el-input
              v-model.trim="addFormData.routerUrl"
              placeholder="请输入相对url，不超过200字"
            ></el-input>
          </el-form-item>
        </section>
        <el-form-item
          label="菜单描述"
          prop="menuDesc"
        >
          <el-input
            type="textarea"
            v-model="addFormData.menuDesc"
            autofocus
            placeholder="请输入菜单描述，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="parentName"
          v-show="isNodeMenu(addFormData.menuType)"
          label="上级菜单"
          required
        >
          <yh-select-tree
            :width="320"
            :data="menuWithOutLeaf"
            :props="defaultProps"
            :value="addFormData.parentName"
            @change="(data) => handleSelectChange('addFormData', data)"
          />
        </el-form-item>
        <el-form-item
          style="display:none"
          prop="parentId"
        >
          <el-input v-model="addFormData.parentId"></el-input>
        </el-form-item>
      </el-form>
      <section slot="footer">
        <el-button @click="visibleAdd=false">取消</el-button>
        <yh-button
          type="primary"
          @click="handleCheckClick"
        >新增菜单</yh-button>
      </section>
    </yh-dialog>
    <!-- 修改页面 -->
    <yh-dialog
      title="修改菜单"
      class="edit-form"
      :visible.sync="visibleEdit"
      :close-on-click-modal="false"
    >
      <el-form
        class="hide-error"
        ref="editForm"
        :model="editFormData"
        label-width="100px"
      >
        <el-form-item
          label="菜单ID"
          prop="id"
        >
          <el-input
            disabled
            :value="editFormData.id"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="菜单类型"
          prop="menuType"
          required
        >
          <el-radio-group
            v-model="editFormData.menuType"
            disabled
          >
            <el-radio label="0">根菜单</el-radio>
            <el-radio label="1">节点菜单</el-radio>
            <el-radio label="2">叶子菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="menuName"
          label="菜单名称"
          required
        >
          <el-input
            placeholder="请输入菜单名称，不超过20字"
            v-model.trim="editFormData.menuName"
          ></el-input>
        </el-form-item>
        <section v-show="isLeafMenu(editFormData.menuType)">
          <el-form-item
            label="菜单url"
            prop="menuUrl"
            required
          >
            <el-input
              v-model.trim="editFormData.menuUrl"
              placeholder="请输入相对url，不超过200字"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="路由url"
            prop="routerUrl"
          >
            <el-input
              v-model.trim="editFormData.routerUrl"
              placeholder="请输入相对url，不超过200字"
            ></el-input>
          </el-form-item>
        </section>
        <el-form-item
          label="菜单描述"
          prop="menuDesc"
        >
          <el-input
            type="textarea"
            v-model="editFormData.menuDesc"
            autofocus
            placeholder="请输入菜单描述，不超过200字"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="isNodeMenu(editFormData.menuType)"
          label="上级菜单"
          prop="parentName"
          required
        >
          <yh-select-tree
            :width="320"
            :data="selectableMenu"
            :props="defaultProps"
            :value="editFormData.parentName"
            @change="(data) => handleSelectChange('editFormData', data)"
          />
        </el-form-item>
      </el-form>
      <section slot="footer">
        <el-button @click="visibleEdit=false">取消</el-button>
        <yh-button
          type="primary"
          @click="handleEditCheckClick"
        >保存</yh-button>
      </section>
    </yh-dialog>
  </el-row>
</template>
<script>
import { getFunctionList, clearBy } from '@/mixins';

export default {
  name: 'MenuManagement',
  mixins: [getFunctionList, clearBy],
  data() {
    const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      userId,
      menuWithOutLeaf: [],
      showMenuTree: false,
      visibleAdd: false,
      visibleEdit: false,
      showEditMenuTree: false,
      addFormData: {
        menuType: '',
        menuName: '',
        menuUrl: '',
        routerUrl: '',
        menuDesc: '',
        parentId: '',
        parentName: '',
      },
      editFormData: {
        menuType: '',
        menuName: '',
        menuUrl: '',
        routerUrl: '',
        menuDesc: '',
        parentId: '',
        parentName: '',
      },
      menuData: [],
      functionList: [],
      labelPosition: 'right',
      formMenu: {},
      isShow: false,
      addShow: false,
      editShow: false,
      parentName: '',
      sysId: '',
      sysName: '',
      parentId: '',
      defaultProps: {
        children: 'children',
        label: 'menuName',
      },
      options: [
        {
          value: '1',
          label: '启用',
        },
        {
          value: '0',
          label: '禁用',
        },
      ],
    };
  },
  computed: {
    $menuTree() {
      return this.$refs.menuTree;
    },
    selectableMenu() {
      function filterSameMenu(menuList, menuId) {
        return menuList.filter(item => item.id !== menuId)
          .map((item) => {
            const child = { ...item };
            if (child.children) {
              child.children = filterSameMenu(child.children, menuId);
            }
            return child;
          });
      }
      return filterSameMenu(this.menuWithOutLeaf, this.formMenu.id);
    },
  },
  watch: {
    visibleAdd() {
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      });
    },
    visibleEdit(isVisible) {
      if (isVisible) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
    },
  },
  filters: {
    menuType(v) {
      const menuMaps = {
        0: '根菜单',
        1: '节点菜单',
        2: '叶子菜单',
      };
      return menuMaps[v] || '';
    },
  },
  mounted() {
    this.listMenu();
  },
  methods: {
    listMenu() {
      this.getData();
    },
    isLeafMenu(menuType) {
      return menuType === '2';
    },
    isNodeMenu(menuType) {
      return menuType >= 1;
    },
    getValidateRules(menuType) {
      const allRules = [{
        prop: 'menuType',
        message: this.$MSG.M0095,
      }, {
        prop: 'menuName',
        message: this.$MSG.M0078,
        validations: [{
          message: this.$MSG.M0079,
          validate: v => v.length <= 20,
        }],
      }, {
        prop: 'menuDesc',
        required: false,
        validations: [{
          message: this.$MSG.M0093,
          validate: v => v.length <= 200,
        }],
      }, {
        prop: 'menuUrl',
        message: this.$MSG.M0081,
        validations: [{
          message: this.$MSG.M0091,
          validate: v => v.length <= 200,
        }],
      }, {
        prop: 'routerUrl',
        required: false,
        validations: [{
          message: this.$MSG.M0092,
          validate: v => v.length <= 200,
        }],
      }, {
        prop: 'parentId',
        message: this.$MSG.M0094,
      }];
      // 根据菜单类型，选择校验条件
      if (this.isLeafMenu(menuType)) {
        return allRules;
      }
      if (this.isNodeMenu(menuType)) {
        allRules.splice(3, 2);
        return allRules;
      }
      allRules.splice(3);
      return allRules;
    },
    handleUpdateClick() {
      this.editFormData = JSON.parse(JSON.stringify(this.formMenu));
      this.visibleEdit = true;
    },
    handleCheckClick() {
      if (this.checkFormData()) {
        this.postMenu(this.userId);
      }
    },
    handleEditCheckClick() {
      if (this.checkEditFormData()) {
        this.updateMenu(this.userId);
      }
    },
    checkFormData() {
      return this.validate(this.getValidateRules(this.addFormData.menuType), this.addFormData);
    },
    checkEditFormData() {
      return this.validate(this.getValidateRules(this.editFormData.menuType), this.editFormData);
    },
    handleAddClick() {
      this.visibleAdd = true;
    },
    handleParentMenuClick() {
      this.showMenuTree = true;
    },
    handleSelectChange(name, data) {
      this[name].parentId = data.id;
      this[name].parentName = data.menuName;
    },
    // 获取菜单数据
    getData() {
      const parames = {
        data: {},
      };
      return this.$_post(this.$API.menuListByRole, parames).then((res) => {
        this.menuData = res.data.list;
        this.menuWithOutLeaf = res.data.selectListMenu;
      });
    },
    // 获取菜单树节点数据
    getNodeData(nodeData) {
      this.isShow = true;
      this.formMenu = nodeData;
      this.formMenu.parentName = this.$menuTree.getNode(nodeData.id)?.parent?.data.menuName;
    },
    // 根据菜单类型，重置需要向后台传递的数据
    pickByMenuType(menu, menuType) {
      const menuKeys = {
        0: ['menuUrl', 'routerUrl', 'parentId'],
        1: ['menuUrl', 'routerUrl'],
        2: [],
      };
      this.clearBy(menu.data, ...menuKeys[menuType]);
    },
    // 添加菜单
    postMenu(userId) {
      const options = {
        data: {
          menuName: this.addFormData.menuName,
          parentId: this.addFormData.parentId,
          routerUrl: this.addFormData.routerUrl,
          menuUrl: this.addFormData.menuUrl,
          menuDesc: this.addFormData.menuDesc,
          menuType: this.addFormData.menuType,
          createUserid: userId,
        },
      };
      this.pickByMenuType(options, this.addFormData.menuType);
      return this.$_post(this.$API.menuSave, options).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0031);
          this.visibleAdd = false;
          this.listMenu();
        } else if (res.errorCode === this.$CODE.existMenu) {
          this.$message.warning(this.$MSG.M0080);
        } else {
          this.$message.error(this.$MSG.M0030);
        }
      });
    },
    getMenuById(id) {
      return this.$_post(this.$API.menuGetById, {
        data: {
          id,
        },
      }).then((res) => {
        this.formMenu = res.data.info;
      });
    },
    updateMenu(userId) {
      const options = {
        data: {
          id: this.editFormData.id,
          menuName: this.editFormData.menuName,
          parentId: this.editFormData.parentId,
          routerUrl: this.editFormData.routerUrl,
          menuUrl: this.editFormData.menuUrl,
          menuDesc: this.editFormData.menuDesc,
          menuType: this.editFormData.menuType,
          updateUserid: userId,
        },
      };
      this.pickByMenuType(options, this.editFormData.menuType);
      return this.$_post(this.$API.menuUpdate, options).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0031);
          this.listMenu();
          this.getMenuById(this.formMenu.id);
          this.visibleEdit = false;
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 删除
    delConfirm() {
      return this.$_yh_confirm(`确定要删除"${this.formMenu.menuName}"菜单?`, '删除菜单', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
      }).then(() => {
        const params = {
          data: {
            id: this.formMenu.id,
            updateUserid: this.userId,
            menuType: this.formMenu.menuType,
          },
        };
        this.deleteMenu(params);
      });
    },
    deleteMenu(params) {
      const { existChildMenu, existFeature, success } = this.$CODE;
      const operation = {
        [success]: () => {
          this.isShow = false;
          this.addShow = false;
          this.editShow = false;
          this.$message.success(this.$MSG.M0031);
          this.listMenu();
        },
        [existChildMenu]: () => {
          this.$_yh_alert(this.$MSG.M0103);
        },
        [existFeature]: () => {
          this.$_yh_alert(this.$MSG.M0096);
        },
      };
      return this.$_post(this.$API.menuDelete, params).then((res) => {
        if (operation[res.errorCode]) {
          operation[res.errorCode]();
        } else {
          this.$message.error(this.$MSG.M0030);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.select-tree {
  width: 100%;
  position: absolute;
  top: 37px;
  border: 1px solid #dcdfe6;
}
.tree-container {
  height: 100%;
}
.form-table {
  border-left: 1px solid #ddd;
  // TODO:为了解决 chrome 48 - 49 flexbox 高度bug，如果版本升级，可删除
  margin-bottom: 40px;
}
.title {
  color: #409eff;
  font-size: 1.2em;
  padding: 20px 0 20px 20px;
}
.operation-button {
  padding-left: 28px;
}
</style>
<style lang="scss">
.page-menu {
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    border: 0;
    color: #606266;
    cursor: default;
    resize: none;
  }
}
.edit-form {
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
</style>
